(() => {
	angular
		.module('main')
		.controller('ChangePasswordController', ChangePasswordController);

	ChangePasswordController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'accountService'
	];

	function ChangePasswordController(
		$scope,
		$rootScope,
		$location,
		$http,
		accountService
	) {
		const request = {
			confirmChange($rootScope, $http, $location, $scope) {
				delete $rootScope.error;
				const restPathUrl = '/public/rest/user/change/confirm/';
				const confirmPathPart = 'confirm/';
				let url = $location.path();
				const index = url.indexOf(confirmPathPart);

				if (index && index + confirmPathPart.length < url.length) {
					url = url.substring(confirmPathPart.length + index, url.length);
					url = restPathUrl + url;
				} else {
					url = null;
				}
				if (url) {
					$http
						.get(url)
						.then(result => {
							const { data, status } = result;
							if (data) {
								if (data.success) {
									delete $rootScope.error;
									accountService.logoutWeb();
									toastr.success('Login with new password!', 'Success');
								} else {
									$rootScope.error = true;
									$rootScope.error_message = data.message;
								}
								$scope.userActionResult = data;
							}
						})
						.catch(result => {
							const { status } = result;
							$rootScope.error = true;
							$rootScope.error_message = 'Failed request to server';
						});
				}
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			if (!$rootScope.password_token) {
				request.confirmChange($rootScope, $http, $location, $scope);
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/changePasswordController.js